import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

import AuthLayout from '../layouts/AuthLayout';
import AdminRoute from './AdminRoute';
import ArtistRoute from './ArtistRoute';
import PayedRoute from './PayedRouted';
import { getUser } from '../../redux/auth/authSlice';

import routes from './routes';

function ProtectedRoutes() {

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUser())
  });

  return (
    <AuthLayout>
      <Routes>
        {routes.map(({ component: Component, path, exact, isAdmin, isArtist, isPayed }, index) => {
          if (isPayed) {
            return <Route key={index} element={<PayedRoute />}>
              <Route path={`${path}`} key={index} exact={exact} element={<Component />} />
            </Route>
          }

          if (isAdmin) {
            return <Route key={index} element={<AdminRoute />}>
              <Route path={`${path}`} key={index} exact={exact} element={<Component />} />
            </Route>
          }

          if (isArtist) {
            return <Route key={index} element={<ArtistRoute />}>
              <Route path={`${path}`} key={index} exact={exact} element={<Component />} />
            </Route>
          }
          return <Route path={`${path}`} key={index} exact={exact} element={<Component />} />
        })}
      </Routes>
    </AuthLayout>
  );
}

export default ProtectedRoutes;
